import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { App, Project } from '../../models';
import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
/* istanbul ignore file */
export class FileDataService extends HttpBaseService {

    private route = environment.api + 'file/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    downloadFileBlob(app: App, project: Project, uniqueFileName: string): Observable<Blob> {
        const url = `${this.route}apps/${app.id}/projects/${project.id}/${uniqueFileName}`;
        return this.httpDownload(url);
    }

    downloadSummaryProjectFileBlob(app: App, project: Project, uniqueFileName: string): Observable<Blob> {
        const url = `${this.route}apps/${app.id}/summary-projects/${project.id}/${uniqueFileName}`;
        return this.httpDownload(url);
    }
}
